<template>
  <span class="logo" role="img" :aria-label="label" :title="label" :style="{ width: `${size}px`, height: `${size}px` }">
    <FavIcon :domain="domain" :size="Math.round((size * 2) / 3)" :fetch-size="FAVICON_PROBE_SIZE" />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import FavIcon from '../../components/FavIcon.vue'
import { FAVICON_PROBE_SIZE } from '../../services/favicons'

const props = withDefaults(defineProps<{ domain: string; name: string | null; size?: number }>(), { size: 30 })

const label = computed(() => props.name || props.domain)
</script>

<style scoped>
/* Companies get rounded squares; people keep circles. */
.logo { display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; border-radius: var(--radius-md); background: var(--color-bg-subtle); }
</style>
